import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

//'http://localhost:8443/api/v1/nomina/documentos';
const BASE_API = `${BASE_URL}/nomina/documentos`;

//console.log('BASE_API en empleadoDocumentoService:', BASE_API);
const API_URL_CARGAR = `${BASE_API}/cargar`;
const API_URL_EDITAR = `${BASE_API}/editar`;

const obtenerConfigFormData = () => {
    const token = localStorage.getItem('jwt')?.replaceAll('"', '') || '';
    return {
        headers: {
            Authorization: 'Bearer ' + token
        }
    };
};

// --- FUNCIÓN GENÉRICA DE ENVÍO ---
export const guardarDocumentoNomina = async (dto, archivo) => {
    const formData = new FormData();

    // 1. Campos Obligatorios del Backend
    if (dto.id) formData.append('id', dto.id);
    formData.append('entidadId', dto.entidadId);
    formData.append('nombreEntidad', 'EMPLEADO');
    formData.append('codigoTipoDocumento', dto.codigoTipoDocumento);

    // 2. Campos Opcionales
    if (dto.referenciaDetalle) formData.append('referenciaDetalle', dto.referenciaDetalle);
    if (dto.descripcion) formData.append('descripcion', dto.descripcion);
    if (dto.categoriaId) formData.append('categoriaId', dto.categoriaId);

    // 3. Fechas
    if (dto.fechaInicio) formData.append('fechaInicio', dto.fechaInicio);
    if (dto.fechaFin) formData.append('fechaFin', dto.fechaFin);
    if (dto.fechaEmision) formData.append('fechaEmision', dto.fechaEmision);

    // 4. Archivo (Obligatorio solo si es nuevo)
    if (archivo) {
        const archivosArray = Array.isArray(archivo) ? archivo : [archivo];

        archivosArray.forEach((file) => {
            // Verificación de seguridad para no enviar nulos
            if (file) {
                formData.append('archivos', file, file.name);
            }
        });
    } else if (!dto.id) {
        throw new Error('El archivo es obligatorio para registros nuevos');
    }

    // 5. DETERMINACIÓN DE URL (SIN EL "/" INICIAL)
    let urlFinal = dto.id ? `${API_URL_EDITAR}/${dto.id}` : API_URL_CARGAR;
    console.log('DTO recibido en guardarDocumentoNomina:', urlFinal);

    // 6. LLAMADA AXIOS (USANDO urlFinal)
    const response = await axios.post(urlFinal, formData, obtenerConfigFormData());
    return response.data;
};

export const obtenerDocumentosPorEmpleado = async (empleadoId) => {
    const urlFinal = `${BASE_API}/por-empleado/${empleadoId}`;
    const response = await axios.get(urlFinal, obtenerConfigFormData());
    return response.data;
};

// --- ADAPTADORES ESPECÍFICOS (TODOS CON id: datos.id) ---

export const guardarLicenciaDeEmpleado = async (empleadoId, datos, archivo) => {
    return await guardarDocumentoNomina(
        {
            id: datos.id,
            entidadId: empleadoId,
            codigoTipoDocumento: datos.codigoTipoDocumento || 'NOM-0000-0015-0000',
            categoriaId: datos.categoria_id,
            referenciaDetalle: datos.numero,
            descripcion: `Licencia de Conducir`,
            fechaInicio: datos.fecha_inicio,
            fechaFin: datos.fecha_fin
        },
        archivo
    );
};

export const guardarLibretaDeEmpleado = async (empleadoId, datos, archivo) => {
    return await guardarDocumentoNomina(
        {
            id: datos.id,
            entidadId: empleadoId,
            codigoTipoDocumento: datos.codigoTipoDocumento || 'NOM-0000-0015-0001',
            categoriaId: datos.categoriaId || datos.categoria_id,
            referenciaDetalle: datos.referenciaDetalle || datos.numero,
            descripcion: 'Libreta Militar',
            fechaInicio: datos.fechaInicio || datos.fecha_inicio,
            fechaFin: datos.fechaFin || datos.fecha_fin
        },
        archivo
    );
};

export const guardarEducacionDeEmpleado = async (empleadoId, datos, archivo) => {
    return await guardarDocumentoNomina(
        {
            id: datos.id,
            entidadId: empleadoId,
            codigoTipoDocumento: datos.codigoTipoDocumento || 'NOM-0000-0015-0002',
            categoriaId: datos.categoriaId || datos.categoria_id,
            referenciaDetalle: datos.referenciaDetalle || datos.numero || datos.institucion,
            descripcion: datos.descripcion || `${datos.institucion} - ${datos.titulo_nombre}`,
            fechaInicio: datos.fechaInicio || datos.fecha_inicio,
            fechaFin: datos.fechaFin || datos.fecha_fin
        },
        archivo
    );
};

export const guardarHistorialDeEmpleado = async (empleadoId, datos, archivo) => {
    return await guardarDocumentoNomina(
        {
            id: datos.id,
            entidadId: empleadoId,
            codigoTipoDocumento: datos.codigoTipoDocumento || 'NOM-0000-0015-0003',
            categoriaId: datos.categoriaId || datos.categoria_id,
            referenciaDetalle: datos.referenciaDetalle || datos.numero,
            descripcion: datos.descripcion || datos.observaciones,
            fechaInicio: datos.fechaInicio || datos.fecha_inicio || datos.fecha,
            fechaFin: datos.fechaFin || datos.fecha_fin,
            fechaEmision: datos.fechaEmision
        },
        archivo
    );
};

export const guardarOtrosDocumentosDeEmpleado = async (empleadoId, datos, archivo) => {
    return await guardarDocumentoNomina(
        {
            id: datos.id,
            entidadId: empleadoId,
            codigoTipoDocumento: datos.codigoTipoDocumento || 'NOM-0000-0015-0004',
            categoriaId: datos.categoriaId || datos.categoria_id,
            referenciaDetalle: datos.referenciaDetalle || datos.numero,
            descripcion: datos.descripcion || datos.observaciones,
            fechaInicio: datos.fechaInicio || datos.fecha_inicio,
            fechaFin: datos.fechaFin || datos.fecha_fin
        },
        archivo
    );
};

export const guardarPensionDeEmpleado = async (empleadoId, datos, archivo) => {
    return await guardarDocumentoNomina(
        {
            id: datos.id,
            entidadId: empleadoId,
            codigoTipoDocumento: datos.codigoTipoDocumento || 'NOM-0000-0015-0005',
            categoriaId: datos.categoriaId || 1,
            referenciaDetalle: 'DOC-PENSION',
            descripcion: 'Documento de Pensión Alimentaria',
            fechaInicio: new Date().toISOString().split('T')[0]
        },
        archivo
    );
};

export const eliminarDocumento = async (documentoId) => {
    // Con token: el endpoint ya no es publico (seguridad S-0, 05/10/2026).
    const response = await axios.delete(`${BASE_API}/${documentoId}`, obtenerConfigFormData());
    return response.data;
};

export const visualizarDocumento = async (documentoId) => {
    const url = `${BASE_API}/${documentoId}/contenido`;

    const config = obtenerConfigFormData();

    config.responseType = 'blob';

    const response = await axios.get(url, config);

    return response.data;
};

export const descargarDocumentoBlob = async (documentoId) => {
    // Ajusta la URL base según tu configuración
    //const url = `/opem-service/documentos/${documentoId}/contenido`;
    const url = `${BASE_API}/${documentoId}/contenido`;
    // IMPORTANTE: responseType 'blob' es la clave para archivos
    // Con token: el endpoint ya no es publico (seguridad S-0, 05/10/2026).
    const response = await axios.get(url, { ...obtenerConfigFormData(), responseType: 'blob' });
    return response.data;
};

//**********  CODIGO NUEVO
export const getDocumentoCabByEmpleadoYTipo = async (empleadoId, codigoTipoReg) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/nomina/documentoCab/entidadTipoReg/${empleadoId}/${codigoTipoReg}`,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (err) {
        console.error('Error al obtener Documentos Cabecera');
        throw new Error('Error al conseguir documentosCab');
    }
};

export const guardarDocumentosCab = async (objDatos, archivos) => {
    try {
        const formData = new FormData();

        formData.append('entidadId', objDatos.entidadId);
        formData.append('nombreEntidad', objDatos.nombreEntidad);
        formData.append('categoriaConfDetId', objDatos.categoriaConfDetId);
        formData.append('referenciaDetalle', objDatos.referenciaDetalle);
        formData.append('descripcion', objDatos.descripcion);

        formData.append('fechaInicio', objDatos.fechaInicio);
        formData.append('fechaFin', objDatos.fechaFin);
        formData.append('fechaEmision', objDatos.fechaEmision);
        formData.append('codigoTipoDocumento', objDatos.codigoTipoDocumento);

        if (archivos) {
            //formData.append('archivos', archivo);
            archivos.forEach((file) => {
                formData.append('archivos', file, file.name);
            });
        }
        const response = await axios.post(
            `${BASE_URL}/nomina/documentoCab/crear`,
            formData,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error al Crear Documentos Cabecera');
        throw new Error('Error al Crear Documentos Cabecera');
    }
};

export const modificarDocumentosCab = async (objDatos, archivos) => {
    try {
        const formData = new FormData();

        formData.append('documentoCabId', objDatos.documentoCabId);
        formData.append('entidadId', objDatos.entidadId);
        formData.append('nombreEntidad', objDatos.nombreEntidad);
        formData.append('categoriaConfDetId', objDatos.categoriaConfDetId);
        formData.append('referenciaDetalle', objDatos.referenciaDetalle);
        formData.append('descripcion', objDatos.descripcion);

        formData.append('fechaInicio', objDatos.fechaInicio);
        formData.append('fechaFin', objDatos.fechaFin);
        formData.append('fechaEmision', objDatos.fechaEmision);
        formData.append('codigoTipoDocumento', objDatos.codigoTipoDocumento);

        if (archivos) {
            //formData.append('archivos', archivo);
            const filesArray = Array.isArray(archivos) ? archivos : [archivos];
            filesArray.forEach((file) => {
                formData.append('archivos', file, file.name);
            });
        }
        const response = await axios.put(
            `${BASE_URL}/nomina/documentoCab/modificar`,
            formData,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error al Mdificar Documentos Cabecera');
        throw new Error('Error al Modificar Documentos Cabecera');
    }
};

export const getDocumentoPorCabecera = async (cabeceraDocId) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/nomina/documentos/cabecera/${cabeceraDocId}`,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error al recuperar Documentos');
        throw new Error('Error al recuperar Documentos');
    }
};

export const anulaDocumentoCab = async (documentoCabId) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/nomina/documentoCab/anular/${documentoCabId}`,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error Eliminar DocumentoCab');
        throw new Error('Error Eliminar DocumentoCab');
    }
};

export const recuperaDocumentosXTipo = async (objPost) => {
    try {
        //console.log ('------EJECUTANDO POR ... ', objPost)
        const response = await axios.post(
            `${BASE_URL}/nomina/documentoCab/reporte/tipoRegistro`,
            objPost,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error recuperar Documentos');
        throw new Error('Error recuperar Documentos');
    }
};

export const recuperaTelefonosXEmpleado = async (objPost) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/nomina/empleado/telefono/reporte`,
            objPost,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error recuperar Telefonos');
        throw new Error('Error recuperar Telefonos');
    }
};

export const recuperaFamliaresXEmpleado = async (objPost) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/nomina/empleado/familiar/reporte`,
            objPost,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error recuperar Familiares');
        throw new Error('Error recuperar Familiares');
    }
};

export const recuperaExperienciaXEmpleado = async (objPost) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/nomina/empleado/experiencia/reporte`,
            objPost,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error recuperar Experiencia');
        throw new Error('Error recuperar Experiencia');
    }
};

export const recuperaDatosPuesto = async (identificador) => {
    //const borrar = '0922354832';
    try {
        const response = await axios.get(
            `${BASE_URL}/turnotrabajo/infoPersona/${identificador}`,
            obtenerConfigFormData()
        );
        return response.data || {};
    } catch (err) {
        if (err.response && err.response.status === 404) {
            return {};
        } else {
            console.error('Error recuperar Datos de puesto');
            throw new Error('Error recuperar Datos de puesto');
        }
    }
};

export const recuperaDotacionPorEmpleado = async (objPost) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/nomina/dotacion/reporte`,
            objPost,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error recuperar Dotaciones');
        throw new Error('Error recuperar Dotaciones');
    }
};

export const resetearCodigoEmp = async (objData) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/nomina/empleado/codigoUnico`,
            objData,
            obtenerConfigFormData()
        );
        return response.data;
    } catch (error) {
        console.error('Error al Resetear el Codigo');
        throw error;
    }
};
